import React from 'react';
class CnDrawerHeader extends React.Component {
    static __type = 'DrawerHeader';
    render() {
        return React.createElement("div", { className: "cn-ui-m-drawer-header" }, this.props.children);
    }
}
export { CnDrawerHeader };
